import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Progress20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_909)'>
      <path
        d='M18.25 10C18.25 5.44365 14.5563 1.75 9.99997 1.75C9.44803 1.75 8.90947 1.8041 8.38906 1.90705L8.09796 0.435565C8.71372 0.313749 9.34977 0.25 9.99997 0.25C15.3847 0.25 19.75 4.61522 19.75 10C19.75 15.3848 15.3847 19.75 9.99997 19.75C9.34977 19.75 8.71372 19.6863 8.09796 19.5644L8.38906 18.093C8.90946 18.1959 9.44803 18.25 9.99997 18.25C14.5563 18.25 18.25 14.5563 18.25 10Z'
        fill='currentColor'
      />
      <path
        d='M4.58219 18.1073C3.51926 17.3957 2.60426 16.4807 1.89265 15.4178L3.1391 14.5833C3.74164 15.4833 4.51667 16.2583 5.41667 16.8609L4.58219 18.1073Z'
        fill='currentColor'
      />
      <path
        d='M1.89265 4.58222C2.60426 3.51929 3.51926 2.6043 4.58219 1.89268L5.41667 3.13914C4.51667 3.74167 3.74164 4.5167 3.1391 5.4167L1.89265 4.58222Z'
        fill='currentColor'
      />
      <path
        d='M0.435533 8.09799L1.90701 8.38909C1.70111 9.4299 1.70111 10.5701 1.90701 11.6109L0.435533 11.902C0.191899 10.6705 0.191899 9.32951 0.435533 8.09799Z'
        fill='currentColor'
      />
      <path
        d='M9.02588 13.5865L14.555 7.50449L13.4451 6.49548L8.97417 11.4135L7.03035 9.46966L5.96969 10.5303L9.02588 13.5865Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_909'>
        <rect
          width='20'
          height='20'
          fill='white'
          transform='matrix(0 1 -1 0 20 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Progress20.displayName = 'Progress20';
export default Progress20;
